import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';

export interface RoleOption {
  value: string;
  label: string;
}

const ROLES_STALE_TIME = 1000 * 60 * 60 * 24; // 24 hours

export const roleKeys = {
  all: ['roles'] as const,
};

export const useRolesQuery = () => {
  return useQuery({
    queryKey: roleKeys.all,
    queryFn: async () => {
      const { data } = await client.get<{ body: RoleOption[] }>('/services/roles');
      return data.body;
    },
    staleTime: ROLES_STALE_TIME,
    gcTime: ROLES_STALE_TIME,
  });
};
